'use strict';

import template from './vk_login.html';

const controller = [
  '$state',
  '$stateParams',
  'vk',

  function ($state, $stateParams, vk) {
    const code = $stateParams.code;

    if (code) {
      this.isLoading = true;
      vk.loginWithCode($stateParams.code)
        .finally(() => {
          $state.go('intro');
          this.isLoading = false;
        });
    } else {
      $state.go('intro');
    }
  }
];

const saVkLogin = [
  function () {
    return {
      template: template,
      replace: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saVkLogin;



// WEBPACK FOOTER //
// ./app/src/modules/vk_login/vk_login.component.js